import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/home",
    children: [],
  },
  {
    path: "/home",
    name: "首页",
    component: HomeView,
  },
  {
    path: "/privacy",
    name: "隐私生明",
     component: () =>
    import(/* webpackChunkName: "about" */ "../views/privacyStatement.vue"),
  },
  {
    path: "/news",
    name: "最新资讯",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/news.vue"),
  },
  {
    path:'/naturals',
    name:'备份首页',
    component: () => import("../views/naturals.vue"),
    redirect: "/naturals/companyNotice",
    children:[
   {
        path: "/naturals/companyActivity",
        name: "协会活动",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/companyActivity.vue"),
      },
      {
        path: "/naturals/companyIndustry",
        name: "资讯备份",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/companyIndustry.vue"),
      },
      {
        path: "/naturals/companyNotice",
        name: "行业资讯",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/companyNotice.vue"),
      },
    ]
  },
  {
    path: "/test",
    name: "test",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/test.vue"),
    redirect: "/test/notices",
    children: [
      {
        path: "notices",
        name: "资讯",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/notices.vue"),
      },
      // {
      //   path: "move",
      //   name: "协会活动",
      //   component: () =>
      //     import(/* webpackChunkName: "about" */ "../views/move.vue"),
      // },
    ],
  },
  {
    path: "/association",
    name: "简介",
    component: () => import("../views/association.vue"),
    redirect: "/association/general",
    children: [
      {
        path: "/association/general",
        name: "协会概况",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/general.vue"),
      },
      {
        path: "/association/proceeding",
        name: "协会会刊",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/proceeding.vue"),
      },
      {
        path: "/association/rules",
        name: "协会章程",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ru.vue"),
      },
    ],
  },
  {
    path: "/about",
    name: "联系信息",
    component: () => import("../views/about.vue"),
    redirect: "/about/contactInfo",
    children: [
      {
        path: "/about/contactInfo",
        name: "联系我们",
        component: () => import("../views/contactInfo.vue"),
      },
      {
        path: "/about/onMessage",
        name: "在线留言",
        component: () => import("../views/onMessage.vue"),
      },
      {
        path: "/about/join",
        name: "申请入会",
        component: () => import("../views/join.vue"),
      },
    ],
  },
  {
    path: "/notice",
    name: "通知公告",
    component: () => import("../views/notice.vue"),
  },
  {
    path: "/directory",
    name: "企业名录",
    component: () => import("../views/directory.vue"),
    redirect:'/directory/production',
    children:[
      {
        path: "/directory/production",
        name: "通知公告",
        component: () => import("../views/production.vue"),
      },
    ]
  },
  {
    path: "/warning/war",
    name: "外贸预警",
    component: () => import("../views/warning.vue"),
    redirect: "/warning/war",
    children: [
      {
        path: "/warning/war",
        name: "外贸预警",
        component: () => import("../views/forewarning.vue"),
      }
    ],
  },
  {
    path: "/earlywar",
    name: "行业专栏",
    component: () => import("../views/earlywar.vue"),
    redirect: "/earlywar/exhibition",
    children: [
      {
        path: "/earlywar/industryColumn",
        name: "行业发展",
        component: () => import("../views/industryColumn.vue"),
      },
 
      {
        path: "/earlywar/exhibition",
        name: "展会信息",
        component: () => import("../views/exhibition.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  next();
  window.scrollTo(0,0)
});
export default router;
